import React, { useState } from 'react';
import { FilterIcon, ChevronDownIcon, XIcon } from 'lucide-react';
export const DashboardFilters = ({
  onFilterChange
}) => {
  const [isExpanded, setIsExpanded] = useState(true);
  const [selectedFilters, setSelectedFilters] = useState({
    period: 'month',
    region: [],
    product: [],
    status: []
  });
  const handleFilterChange = (key, value) => {
    const newFilters = {
      ...selectedFilters,
      [key]: value
    };
    setSelectedFilters(newFilters);
    onFilterChange(newFilters);
  };
  const clearFilters = () => {
    const resetFilters = {
      period: 'month',
      region: [],
      product: [],
      status: []
    };
    setSelectedFilters(resetFilters);
    onFilterChange(resetFilters);
  };
  return <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-347">
      <div className="p-4 border-b border-gray-200 flex items-center justify-between cursor-pointer hover:bg-gray-50 transition-colors" onClick={() => setIsExpanded(!isExpanded)} data-id="element-348">
        <div className="flex items-center gap-3" data-id="element-349">
          <FilterIcon className="h-5 w-5 text-blue-600" data-id="element-350" />
          <span className="font-medium text-gray-900" data-id="element-351">
            Filtros de Dashboard
          </span>
          {Object.values(selectedFilters).some(v => Array.isArray(v) ? v.length > 0 : v !== '') && <span className="bg-blue-100 text-blue-700 text-xs font-medium px-2.5 py-0.5 rounded-full" data-id="element-352">
              Filtros activos
            </span>}
        </div>
        <div className="flex items-center gap-2" data-id="element-353">
          {isExpanded && Object.values(selectedFilters).some(v => Array.isArray(v) ? v.length > 0 : v !== '') && <button onClick={e => {
          e.stopPropagation();
          clearFilters();
        }} className="text-sm text-red-600 hover:text-red-800 font-medium" data-id="element-354">
                Limpiar filtros
              </button>}
          <ChevronDownIcon className={`h-5 w-5 text-gray-500 transition-transform duration-200 ${isExpanded ? 'rotate-180' : ''}`} data-id="element-355" />
        </div>
      </div>
      {isExpanded && <div className="p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 animate-fadeIn" data-id="element-356">
          <div className="space-y-2" data-id="element-357">
            <label className="block text-sm font-medium text-gray-700" data-id="element-358">
              Periodo
            </label>
            <select value={selectedFilters.period} onChange={e => handleFilterChange('period', e.target.value)} className="w-full p-2.5 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500" data-id="element-359">
              <option value="day" data-id="element-360">Hoy</option>
              <option value="week" data-id="element-361">Esta semana</option>
              <option value="month" data-id="element-362">Este mes</option>
              <option value="quarter" data-id="element-363">Este trimestre</option>
              <option value="year" data-id="element-364">Este año</option>
            </select>
          </div>
          <div className="space-y-2" data-id="element-365">
            <label className="block text-sm font-medium text-gray-700" data-id="element-366">
              Región
            </label>
            <select multiple value={selectedFilters.region} onChange={e => handleFilterChange('region', Array.from(e.target.selectedOptions, option => option.value))} className="w-full p-2.5 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500" data-id="element-367">
              <option value="north" data-id="element-368">Norte</option>
              <option value="south" data-id="element-369">Sur</option>
              <option value="east" data-id="element-370">Este</option>
              <option value="west" data-id="element-371">Oeste</option>
            </select>
            <p className="text-xs text-gray-500" data-id="element-372">
              Mantén presionado Ctrl para seleccionar varios
            </p>
          </div>
          <div className="space-y-2" data-id="element-373">
            <label className="block text-sm font-medium text-gray-700" data-id="element-374">
              Producto
            </label>
            <select multiple value={selectedFilters.product} onChange={e => handleFilterChange('product', Array.from(e.target.selectedOptions, option => option.value))} className="w-full p-2.5 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500" data-id="element-375">
              <option value="product1" data-id="element-376">Producto A</option>
              <option value="product2" data-id="element-377">Producto B</option>
              <option value="product3" data-id="element-378">Producto C</option>
            </select>
            <p className="text-xs text-gray-500" data-id="element-379">
              Mantén presionado Ctrl para seleccionar varios
            </p>
          </div>
          <div className="space-y-2" data-id="element-380">
            <label className="block text-sm font-medium text-gray-700" data-id="element-381">
              Estado
            </label>
            <div className="flex flex-wrap gap-2" data-id="element-382">
              {['pending', 'approved', 'rejected'].map(status => <button key={status} onClick={() => {
            const newStatus = selectedFilters.status.includes(status) ? selectedFilters.status.filter(s => s !== status) : [...selectedFilters.status, status];
            handleFilterChange('status', newStatus);
          }} className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${selectedFilters.status.includes(status) ? 'bg-blue-100 text-blue-800 hover:bg-blue-200' : 'bg-gray-100 text-gray-800 hover:bg-gray-200'}`} data-id="element-383">
                  {status === 'pending' && 'Pendiente'}
                  {status === 'approved' && 'Aprobado'}
                  {status === 'rejected' && 'Rechazado'}
                </button>)}
            </div>
          </div>
        </div>}
    </div>;
};